
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Clients Satisfaits' },
    { number: '25+', label: "Années d'Expérience" },
    { number: '24/7', label: 'Support Client' },
    { number: '99%', label: 'Fiabilité' }
  ];

  const advantages = [
    {
      icon: 'ri-award-line',
      title: 'Expertise Reconnue',
      description: "Plus de 25 ans d'expérience dans le domaine de la sécurité avec une équipe d'experts certifiés."
    },
    {
      icon: 'ri-tools-line',
      title: 'Installation Professionnelle',
      description: "Nos techniciens qualifiés assurent une installation rapide et conforme aux normes en vigueur."
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Support 24h/24',
      description: "Service client disponible 24h/24 et 7j/7 pour tous vos besoins de maintenance et dépannage."
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Garantie Totale',
      description: "Tous nos équipements et installations sont garantis avec un service après-vente de qualité."
    }
  ];

  return (
    <section id="apropos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Pourquoi Choisir <span className="text-red-600">Cobra Sécurité</span> ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Depuis plus de 25 ans, nous accompagnons les entreprises dans la protection 
            de leurs biens et de leurs équipes avec des solutions sur mesure.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="bg-red-50 rounded-2xl p-6 mb-4">
                <div className="text-4xl md:text-5xl font-bold text-red-600 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-7

00 font-semibold">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/557599d0be373cec0d1d96bb88f6df39.jpg"
                alt="Techniciens Cobra Sécurité"
                className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-red-600 text-white p-6 rounded-2xl shadow-xl">
                <div className="text-2xl font-bold">25+</div>
                <div className="text-sm">Années d'expérience</div>
              </div>
            </div>
          </div>

          {/* Advantages */}
          <div className="order-1 lg:order-2 space-y-8">
            {advantages.map((advantage) => (
              <div key={advantage.title} className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${advantage.icon} text-red-600 text-xl`}></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    {advantage.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
